<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p style="text-align: center;"><img alt="" src="media/file0.jpg" style="width:2.39583in;height:3.75534in"/></p><br/>
<p style="text-indent:00em;">Richard Clarke was born in 1969, a proud Bradfordian. A trained PE teacher at Carnegie College, Leeds, he spent nearly 30 years in the education sector. The majority of his experience was as Head of Pastoral at a large secondary school in Halifax.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?8df2b384